import { Fragment, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchAPI } from '../../../api/request';
import Loading from '../../../components/common/Loading.component';
import Alert from '../../../components/common/Alert.component';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from '../../../components/common/Confirm.component';
import _ from 'lodash';
import Button from '../../../components/form/components/Button.component';

const YachtDeletePage = ({
  module: { query, tag, remove },
  id,
  variant = 'outlined',
  onSuccessDelete = () => {},
  disabled = false,
}) => {
  const navigate = useNavigate();
  const { id: id_yacht } = useParams();

  const [loading, setLoading] = useState(false);
  const { jwt } = useSelector((state) => state.login);
  const [error, setError] = useState(null);

  const [openDelete, setOpenDelete] = useState(false);
  const userAuth = useSelector((state) => state.login?.user);

  const onClose = useCallback(() => {
    setOpenDelete(false);
  }, [setOpenDelete]);

  const onOpen = useCallback(() => {
    setOpenDelete(true);
  }, [setOpenDelete]);

  const onSuccess = useCallback(() => {
    setLoading(false);
    setError(null);
    setOpenDelete(false);
    onSuccessDelete();
    if (remove?.navigate) navigate(remove?.navigate);
  }, [navigate, setLoading, onSuccessDelete, remove]);

  const onError = useCallback((error) => {
    setLoading(false);
    setError(error);
    // eslint-disable-next-line
  }, []);

  const onSubmit = useCallback(() => {
    if (userAuth.permissions[_.toUpper(tag)]?.DELETE === 'true') {
      setError(false);
      setLoading(true);
      fetchAPI(query.delete.settings, { id: id || id_yacht }, '', {}, jwt)
        .then(onSuccess)
        .catch((error) => onError(error));
    }
  }, [id, jwt, onError, onSuccess, query, userAuth, tag, id_yacht]);

  return (
    <Fragment>
      {loading && <Loading />}
      {error && (
        <Alert severity='error'>
          {error?.response?.data?.error?.message
            ? error?.response?.data?.error?.message
            : 'An error has occurred'}
        </Alert>
      )}

      <Button
        onClick={onOpen}
        variant={variant}
        startIcon={<DeleteIcon />}
        color='error'
        disabled={disabled}
      >
        Delete
      </Button>

      <ConfirmDialog
        open={openDelete}
        onClose={onClose}
        title='Are you sure you want to delete this?'
        description='It will be deleted permanently. You cannot undo this action.'
        cancelAction={onClose}
        confirmAction={onSubmit}
      />
    </Fragment>
  );
};

export default YachtDeletePage;
